<div class="bn-dialog bn-user-disabled p-2 pb-0">
  <div
    class="bn-dialog__close"
    (click)="onClose()">
    <fa-icon
      aria-label="Close"
      icon="xmark"
      size="lg" />
  </div>
  <div class="bn-dialog__body">
    <div class="row">
      <div class="col-6 d-none d-md-block">
        <div class="bn-user-disabled__title ms-6">Your account has been <strong>disabled</strong>.</div>
        <div class="text-center">
          <img
            class="bn-user-disabled__image"
            src="/assets/web-ui/images/bunny-account-disabled.svg"
            width="80%" />
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="bn-user-disabled__title d-block d-md-none text-center text-md-left ms-md-6">Your account has been <strong>disabled</strong>.</div>
        <div class="bn-user-disabled__content">
          <div class="bn-user-disabled__content__title">You have a negative balance!</div>
          <p>
            Your account has been temporarily disabled due to a negative balance.
            <br />
            <br />
            <strong>To hop back in and restore your services, please recharge your account.</strong>
          </p>
          <p>
            If you think this was a mistake or need a helping paw, our Super Bunnies™ are ready to help. Feel free to reach out, and we’ll be happy to assist
            you!
          </p>
          <hr class="mt-3 mb-4" />
          <div>
            <div class="row">
              <p class="bn-user-disabled__content__title">Current month’s usage</p>
              <div class="col-4">
                <fa-duotone-icon
                  class="bn-user-disabled__usage__item__icon"
                  size="lg"
                  [icon]="['fad', 'chart-mixed-up-circle-dollar']" />
                @if (billingData() !== null) {
                  <div class="bn-user-disabled__usage__item__value">
                    {{ billingData()?.ThisMonthCharges ?? 0 | currency: 'USD' : 'symbol' : '1.2' }}
                  </div>
                }
                <div>Usage</div>
              </div>

              <div class="col-4">
                <fa-duotone-icon
                  class="bn-user-disabled__usage__item__icon"
                  size="lg"
                  [icon]="['fad', 'chart-simple']" />
                @if (billingData() !== null) {
                  <div class="bn-user-disabled__usage__item__value">
                    {{ (billingData()?.MonthlyBandwidthUsed ?? 0 | formatByte).formatted }}
                  </div>
                }
                <div>Bandwidth</div>
              </div>

              <div class="col-4">
                <fa-duotone-icon
                  class="bn-user-disabled__usage__item__icon"
                  size="lg"
                  [icon]="['fad', 'dollar-circle']" />
                @if (billingData() !== null) {
                  <div class="bn-user-disabled__usage__item__value">
                    <b> {{ (averageCost | currency: 'USD' : 'symbol' : '1.0-4') ?? '$0' }} </b>
                  </div>
                }
                <div>Average cost</div>
              </div>
            </div>
          </div>

          <hr class="mt-3" />
          <div class="bn-dialog__actions mt-5">
            <button
              bn-web-ui-button
              itemStyle="primary"
              size="lg"
              [fullWidth]="true"
              (click)="rechargeAccount()">
              Recharge Your Account
            </button>
            <p class="text-center mt-1">
              Need help?
              <a routerLink="/support/tickets/new"> Open a Support Ticket.</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
